module.exports = __webpack_public_path__ + "static/media/horizontal-rule-1px-blue-medium-100.0fef36b2.svg";